module.exports = __webpack_public_path__ + "static/FacebookApp-69f6cae05878264e4c5ff0f53364c7c6.png";